<template>
  <Transition name="fade" mode="out-in">
    <UiBtn
      v-if="isShow"
      :size="$device.isMobile ? 'xs' : 's'"
      color="gray"
      :active="isFavorites"
      icon-only
      icon="common/heart"
      class="fav-btn"
      v-bind="$attrs"
      v-on="$listeners"
    />
  </Transition>
</template>

<script>
export default {
  name: 'FavoriteBtn',
  props: {
    isFavorites: { type: Boolean },
    isShow: { type: Boolean },
    isInverse: { type: Boolean, default: false },
  },
}
</script>
